import axios from 'axios';
import BaseCrud from './baseCrud';
const crud = new BaseCrud('campus', 'campuses');

export const state = () => ({ ...crud.state });

export const getters = {
    ...crud.getters
};

export const mutations = {
    ...crud.mutations
};

export const actions = {
    ...crud.actions,

    changeDefault(vuexContext, id) {
        return axios.$post(`/admin/campuses/${id}/default`);
    },

    getDefault() {
        return axios.$get('/admin/campuses/default');
    },

    getCampusesTagsCount(vuexContext, tagId) {
        return axios.$get(`/admin/campuses/getCampusesTagsCount/${tagId}`);
    }
};
